<script>
    export default {
        props: {
            projectId: {
                required: true,
                type: Number
            },
            disabled: {
                required: true,
                type: Boolean
            },
            formConfiguration: {
                required: true,
                type: Object
            },
            formData: {
                required: true,
                type: Object
            },
            autoSave: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            mpid() {
                return Object.keys(this.$store.state.mp_layout.measure_pickers)[0];
            },
            formActions() {
                return [{
                    label: 'Update',
                    name: 'submit',
                    action: 'submitForm'
                }]
            },
        },

        methods: {
            recalculateSavingsAndCost() {
                this.$store.dispatch('mp_project_measures/getProjectMeasuresForCurrentScenarioAndPhase', this.mpid);
                this.$store.dispatch('mp_layout/getMeasureSummary', this.mpid);
                window.notify.message('Successfully updated facility and re-calculated savings and cost.', 'success');
            },
        }

    }
</script>
<template>
    <div class="flex items-center w-full">
        <vue-form
            :form-config="formConfiguration"
            :form-data="Object.assign(formData, {id: projectId})"
            :form-submit-url="'/api/projects/' + projectId + '/customer_information'"
            :auto-save="autoSave"
            :actions="formActions"
            :disabled="disabled"
            @updated="recalculateSavingsAndCost"
        ></vue-form>
    </div>
</template>